import React from 'react';

/**
 * Barre d'actions des pages d'import et de rapprochement : collée en bas de
 * l'écran, même sur une page courte, avec un mot à gauche (ce qui va se
 * passer) et les boutons à droite.
 */
const PiedActions = ({ children, gauche = null }) => (
  <div className="sticky bottom-0 z-10 -mx-4 mt-6 flex flex-wrap items-center justify-between gap-3 border-t bg-gray-50 px-4 py-3">
    <div className="text-sm text-gray-600">{gauche}</div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export default PiedActions;
